import React from 'react';
import { getDate, getTime } from '@quyva/common';
import { FileDownloadList } from '@quyva/shared-ui';
import { useAttachmentDownload } from '../../../hooks/useAttachmentDownload';

export const QuestionContentView = ({ chatObject }) => {
    const { download, loadingPath } = useAttachmentDownload();

    return (
        <>
            <div className='text-slate-700'>{chatObject.question}</div>

            <FileDownloadList
                files={chatObject?.attachments}
                onDownload={download}
                loadingPath={loadingPath}
            />

            <div className='flex justify-between items-between text-xs mt-2 text-texts-secondary300'>
                <div>{getDate(chatObject.timestamp)}</div>
                <div>{getTime(chatObject.timestamp)}</div>
            </div>
        </>
    );
};
